import { BackButton, Loader, RadioButtons, UploadFile } from "@egovernments/digit-ui-react-components";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, Fragment } from "react";
import { Tab, Tabs, Box } from "@mui/material";
import TabPanel from "@egovernments/digit-ui-module-obps/src/pageComponents/TabPanel";
import TLCaption from "../../ApplicationDetails/components/TLCaption";
import { useParams, useHistory } from "react-router-dom";
import DemoParinted from "../../ApplicationDetails/components/RichTextArea";
import { styled } from "@mui/styles";
import EmployeeComponent from "../../ApplicationDetails/RoleAccess12/Employer";
import Architect from "../../ApplicationDetails/RoleAccess12/Architect";
import PersonIcon from "@mui/icons-material/Person";
import { green } from "@mui/material/colors";
import Avatar from "@mui/material/Avatar";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Toast } from "@egovernments/digit-ui-react-components";
import { Button, Dialog, DialogActions, DialogContentText, DialogTitle } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DialogContent from "@mui/material/DialogContent";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import ChatboardCorrespondenceApplicant from "@egovernments/digit-ui-module-obps/src/components/ChatBoard/ChatBoardApplicant/ChatBoardCorrespondenceApplicant";
import AllRemarksList from "../AllRemarks";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";
import Step3 from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/self-approval/Step3";
import ButtonWrapper from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/components/Button";
import axios from "axios";

const StyledTabPanel = styled(TabPanel)(() => ({
  "& .MuiBox-root": { padding: 0 },
}));

const Form12Summary = ({
  formData,
  businessService,
  action,
  edcrDetails,
  setOnAddComments,
  onActionSelect,
  showTimeLine = true,
  applicationData,
  collectionBillDetails,
  workflowDetails,
  timelineStatusPrefix,
  isDataLoading,
  statusAttribute = "status",
  submitAction,
  actionData,
  moduleCode,
}) => {
  const [currentTab, setCurrentTab] = useState("0");
  const [file, setFile] = useState(null);
  const { id } = useParams();
  const history = useHistory();
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [developerRemarks, setDeveloperRemarks] = useState("");
  //const [declarationChecked, setDeclarationChecked] = useState(false);
  const isSelfCert =
    formData?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
    formData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";

  const isSelf = formData?.planOn === "SELF_MAP";

  const hideChatboard = isSelfCert || isSelf;

  const tablist = [
    { label: "Application Info", color: "red" },
    { label: "ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS", color: "green" },
    !hideChatboard && { label: "ChatBoard", color: "green" },
    isSelfCert && formData?.status === "MAKE_PAYMENT_SELF" && { label: "Fee Details", color: "orange" },
  ].filter(Boolean);
  const chatboardIndex = tablist.findIndex((tab) => tab.label === "ChatBoard");
  const feeDetailsIndex = tablist.findIndex((tab) => tab.label === "Fee Details");
  const [currentAction, setCurrentAction] = useState(null);
  const [structureCertificateError, setStructureCertificateError] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [roleFormCode, setRoleFormCode] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [openApplicantPopup, setOpenApplicantPopup] = useState(false);
  const [open, setOpen] = useState(false);
  const closeToast = () => setShowToast(null);
  const Modal = useModal();
  const { t } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const tenantId = stateId;
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const appType = formData?.applicationType;
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const userInfo = Digit.UserService.getUser()?.info || {};
  const userRolesArray = userInfo?.roles.filter((user) => user.code !== "EMPLOYEE");
  const BusinessService = formData?.businessService === `BPA_${appType?.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  console.log("userinforfromform12summary", userInfo);

  const docs = formData?.documents || {};

  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  formData.documents = documents;
  let user = Digit.UserService.getUser();
  // let userSearchdata = Digit.UserService.setUser();
  const tenant = Digit.ULBService.getCurrentTenantId();
  const userRoles = user?.info?.roles?.map((e) => e.code);
  console.log("userRolesArrayFromSuryoday", userRoles);
  const token = user?.access_token;
  const signatureAccess = userDetails?.signature;
  const getUserInfo = async () => {
    const uuid = user?.info?.uuid;
    if (uuid) {
      const usersResponse = await Digit.UserService.userSearch(tenant, { uuid: [uuid] }, {});
      usersResponse && usersResponse.user && usersResponse.user.length && setUserDetails(usersResponse.user[0]);
    }
  };

  const isDeptCert =
    formData?.planOn !== "Self Certification of residential Plot Area upto 300 SqM on approved layouts" &&
    formData?.planOn !== "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  // const isLTP = userRoles.length > 1;
  //const isLTP = !["OWNER", "EMPLOYEE", "CITIZEN"].some((role) => userRoles?.includes(role));
  const isLTP = userRoles?.some((role) => !["OWNER", "EMPLOYEE", "CITIZEN"].includes(role));
  const isOwner = userRoles?.some((role) => role === "OWNER");
  // const isOwner = userRoles?.includes("OWNER");
  // let actions = workflowDetails?.data?.nextActions?.filter((e) => {
  //    if (isDeptCert && isLTP && (e.action === "MAKE_PAYMENT_SELF")) {
  //     return false
  //   }
  //   else if(isDeptCert && !isLTP && (e.action === "MAKE_PAYMENT_SELF")){
  //     return false
  //   }
  //   else if(isSelfCert && !isLTP && (e.action === "MAKE_PAYMENT_SELF" || e.action === "MAKE_PAYMENT")){
  //     return false
  //   }
  //   else if(isSelfCert && isLTP && (e.action === "MAKE_PAYMENT")){
  //     return false
  //   }
  //   return true
  // })
  //let actions = workflowDetails?.data?.nextActions
  console.log(isLTP, isSelfCert, isDeptCert, isOwner, formData, workflowDetails?.data?.nextActions, "actionsshere00000");

  let actions = workflowDetails?.data?.nextActions?.filter((e) => {
    if (isLTP && (e.action === "FORWARD_TO_LTP" || e.action === "REJECTED")) {
      return false;
    } else if (isSelfCert && isOwner && formData?.status === "UPLOAD_DOC") {
      return false;
    } else if (isLTP && (e.action === "FORWARD_TO_OWNER" || e.action === "UPLOAD_DOC")) {
      return false;
    } else if (isDeptCert && !isSelf && e.action === "MAKE_PAYMENT_SELF") {
      return false;
    } else if (isSelfCert && !isLTP && e.action === "MAKE_PAYMENT_SELF") {
      return true;
    } else if (isSelf && e.action === "MAKE_PAYMENT_SELF") {
      return true;
    } else if (isSelf && (e.action === "MAKE_PAYMENT" || e.action === "UPLOAD_DOC" || e.action === "FORWARD_TO_DEPARTMENT")) {
      return false;
    } else if (isSelfCert && isLTP && (e.action === "MAKE_PAYMENT" || e.action === "FORWARD_TO_DEPARTMENT")) {
      return false;
    } else if (
      e.action === "PAYMENT_DONE" ||
      e.action === "PAYMENT_CANCEL" ||
      e.action === "PAYMENT_DONE_CTP" ||
      e.action === "PAYMENT_DONE_EE_TP" ||
      e.action === "PAYMENT_DONE_VC" ||
      e.action === "PAYMENT_DONE_ATP" ||
      e.action === "PAYMENT_DONE_SECT"
    ) {
      return false;
    }
    return true;
  });
  console.log(actions, "actionsshere111111");

  const routetoPay = async () => {
    const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData) };
    const workflow = {
      action: currentAction?.action,
      comment: developerRemarks,
      comments: developerRemarks,
      assignee: null,
      assignes: null,
      varificationDocuments: uploadedFile
        ? [
            {
              documentType: currentAction + " DOC",
              fileName: file?.name,
              fileStoreId: uploadedFile,
            },
          ]
        : null,
    };
    const appData = {
      ...applicationData,
      documents: formData?.documents,
      additionalDetails,
      workflow,
      action: currentAction?.action,
      comment: developerRemarks,
      assignee: null,
      wfDocuments: uploadedFile
        ? [
            {
              documentType: currentAction + " DOC",
              fileName: file?.name,
              fileStoreId: uploadedFile,
            },
          ]
        : null,
    };

    // Fetch bills for each taxHeadEstimate and find the first valid one
    let validBusinessService = null;
    if (applicationData?.taxHeadEstimates && applicationData?.taxHeadEstimates.length > 0) {
      for (const item of applicationData.taxHeadEstimates) {
        const businessService = item.calculationBusinesserviceId;
        const consumerCode = applicationData?.applicationNo;
        try {
          const fetchedBill = await Digit.PaymentService.fetchBill(tenantId, { consumerCode, businessService });
          console.log("fetchedBill", fetchedBill);

          // Check if bill response is valid
          if (fetchedBill && fetchedBill.Bill && fetchedBill.Bill.length > 0) {
            validBusinessService = businessService;
            console.log("Valid bill found for businessService:", validBusinessService);
            break; // Use first valid bill found
          }
        } catch (error) {
          console.log("Error fetching bill for businessService:", businessService, error);
          // Continue to next item if fetch fails
        }
      }
    }

    await submitAction({
      BPA: appData,
    });

    // Use validBusinessService if found, else fall back to original logic
    if (
      applicationData?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
      applicationData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"
    ) {
      history.push(`/digit-ui/citizen/payment/collect/BPA.MAP_SELF_FEE/${`${formData?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`);
    } else if (validBusinessService) {
      history.push(
        `/digit-ui/citizen/payment/collect/${validBusinessService}/${`${formData?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
      );
    } else if (applicationData?.taxHeadEstimates?.length > 1) {
      history.push(
        `/digit-ui/citizen/payment/collect/${`${applicationData?.taxHeadEstimates?.[1]?.calculationBusinesserviceId}`}/${`${formData?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
      );
    } else {
      history.push(
        `/digit-ui/citizen/payment/collect/${`${applicationData?.taxHeadEstimates?.[0]?.calculationBusinesserviceId}`}/${`${formData?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
      );
    }
  };
  const handlePayment = async (nextTab, payload) => {
    try {
      updateApiCall.mutate(
        { BPA: payload },
        {
          onSuccess: (res) => {
            // onSelect("", { ...data, ...res?.BPA?.[0] });
            Modal(
              "Fee Details Updated Successfully",
              `Your Application ${formData?.applicationNo} fee details has been updated successfully`,
              "success",
              null, // no redirectPath
              () => window.location.reload()
            );
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error");
          },
        }
      );
    } catch (error) {
      console.error(error);
      Modal("Update Error", "Something went wrong!!", "error");
    }

    // if (nextTabNo === 4) {
    //   Digit.SessionStorage.set("SUMMARY_TAB", true);
    //   setSummaryshow(true);
    // }
    // setActiveTab(nextTabNo);
    // Digit.SessionStorage.set("SA_CURRENT_TAB", nextTabNo);
  };
  const actionObject = formData?.auditDetails?.lastModifiedTime;
  const currentTime = new Date().getTime();
  const hoursDifference = (currentTime - actionObject) / (1000 * 60 * 60);
  const twentyFourHoursPassed = hoursDifference >= 24;
  const fifteenTimeOut = hoursDifference >= 384;
  setOnAddComments(developerRemarks);

  const onRadioActionSelect = (value) => {
    setCurrentAction(value);
  };
  let improvedDoc = [];
  formData?.PrevStateDocuments?.map((preDoc) => {
    improvedDoc.push({ ...preDoc, module: "OBPS" });
  });
  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });

  formData?.PrevStateNocDocuments?.map((preNocDoc) => {
    improvedDoc.push({ ...preNocDoc, module: "NOC" });
  });
  formData?.nocDocuments?.nocDocuments?.map((nocDoc) => {
    improvedDoc.push({ ...nocDoc, module: "NOC" });
  });

  // const { data: pdfDetails, isLoading: pdfLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, { enabled: improvedDoc?.length > 0 ? true : false });
  let pdfDetails = {};
  let applicationDocs = [],
    nocAppDocs = [];
  if (pdfDetails?.pdfFiles?.length > 0) {
    pdfDetails?.pdfFiles?.map((pdfAppDoc) => {
      if (pdfAppDoc?.module == "OBPS") applicationDocs.push(pdfAppDoc);
      if (pdfAppDoc?.module == "NOC") nocAppDocs.push(pdfAppDoc);
    });
  }

  let consumerCode = formData?.applicationNo;
  const fetchBillParams = { consumerCode };

  const { data: paymentDetails } = Digit.Hooks.useFetchBillsForBuissnessService(
    { businessService: BusinessService, ...fetchBillParams, tenantId: stateId },
    {
      enabled: consumerCode ? true : false,
      retry: false,
    }
  );
  const totalAmount = formData?.paymentDetails?.bill?.billDetails[0]?.amount || paymentDetails?.Bill?.[0]?.billDetails[0]?.amount;
  //Applicant Popup submit
  const handleModal = () => {
    setOpenApplicantPopup(false);
    setTimeout(() => {
      history.push({
        pathname: `/digit-ui/citizen/profile`,
      });
    }, 2000);
  };
  const checkPaymentStatus = async (id) => {
    console.log("insidecheckpaymentstatus", id);

    try {
      let requestInfo = {
        RequestInfo: {
          apiId: "Rainmaker",
          ver: "v1",
          ts: 0,
          action: "_search",
          did: "",
          key: "",
          msgId: "090909",
          requesterId: "",
          authToken: token,
          userInfo: userInfo,
        },
      };
      const Resp = await axios.post(`/pg-service/transaction/v1/_search?transaction=${id}`, requestInfo).then((response) => {
        return response?.data;
      });
      console.log("Responsdhgdhdeygfg", Resp);
      // setScrutinyTable(Resp?.Transaction?.[0]);
      const paymentStatus = Resp?.ResponseInfo?.status;
      Modal("Payment Status", `${paymentStatus}`, "info");
    } catch (error) {
      console.log(error);
    }

    // return response?.data;
  };
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const isEditApplication = window.location.href.includes("editApplication");
  const sendbacktocitizenApp = window.location.href.includes("sendbacktocitizen");
  let routeLink = `/digit-ui/citizen/obps/form11/${formData?.applicationType?.toLowerCase()}/${formData?.serviceType?.toLowerCase()}`;
  if (isEditApplication) routeLink = `/digit-ui/citizen/obps/editApplication/form11/${formData?.tenantId}/${formData?.applicationNo}`;
  if (sendbacktocitizenApp) routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/form11/${formData?.tenantId}/${formData?.applicationNo}`;
  ////
  function OpenImage(imageSource, index, thumbnailsToShow) {
    window.open(thumbnailsToShow?.fullImage?.[0], "_blank");
  }
  const getTimelineCaptions = (checkpoint) => {
    if (checkpoint.state === "OPEN" || (checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/"))) {
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate(applicationData?.auditDetails?.createdTime),
        source: applicationData?.channel || "",
      };
      return <TLCaption data={caption} />;
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      const caption = {
        date: checkpoint?.auditDetails?.lastModified,
        name: checkpoint?.assignes?.[0]?.name,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
        comment: t(checkpoint?.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint?.thumbnailsToShow,
      };
      return <TLCaption data={caption} OpenImage={OpenImage} />;
    } else {
      const caption = {
        date: Digit.DateUtils?.ConvertTimestampToDate(applicationData?.auditDetails?.lastModifiedTime),
        name: checkpoint?.assignes?.[0]?.name,
        wfComment: checkpoint?.wfComment,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
      };
      return <TLCaption data={caption} />;
    }
  };

  function selectFile(e) {
    setFile(e.target.files[0]);
  }
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        const allowedFileTypesRegex = /(.*?)(jpg|jpeg|png|image|pdf)$/i;
        if (file.size >= 5242880) {
          setError(t("CS_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else if (file?.type && !allowedFileTypesRegex.test(file?.type)) {
          setError(t(`NOT_SUPPORTED_FILE_TYPE`));
        } else {
          try {
            const response = await Digit.UploadServices.Filestorage("OBPS", file, Digit.ULBService.getStateId() || tenantId?.split(".")[0]);
            if (response?.data?.files?.length > 0) {
              setUploadedFile(response?.data?.files[0]?.fileStoreId);
            } else {
              setError(t("CS_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            setError(t("CS_FILE_UPLOAD_ERROR"));
          }
        }
      }
    })();
  }, [file]);
  // const handleDeclarationChange = (event) => {
  //   setDeclarationChecked(event.target.checked);
  // };

  useEffect(() => {
    if (!userRoles) return;
    if (
      [
        "BPA_ARCHITECT",
        "BPA_TOWNPLANNER",
        "BPA_ENGINEER",
        "BPA_ARCHITECT_ASSISTANT",
        "BPA_ENGINEER_DIPLOMA",
        "BPA_DRAUGHTSMAN",
        "BPA_SURVEYOR",
      ].includes(userRoles)
    ) {
      setRoleFormCode("true");
    }
  }, [userRoles]);

  const getInspectionDocs = (docs) => {
    let refinedDocs = [];
    docs &&
      docs.map((doc, ind) => {
        refinedDocs.push({
          documentType: (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
          fileStoreId: doc.fileStoreId,
          fileStore: doc.fileStoreId,
          fileName: "",
          dropDownValues: {
            value: (doc.documentType + "_" + doc.documentType.split("_")[1]).replaceAll("_", "."),
          },
        });
      });
    return refinedDocs;
  };

  const getQuestion = (data) => {
    let refinedQues = [];
    var i;
    for (i = 0; i < data?.questionLength; i++) {
      refinedQues.push({
        remarks: data[`Remarks_${i}`],
        question: data?.questionList[i].question,
        value: data?.[`question_${i}`]?.code,
      });
    }
    return refinedQues;
  };

  const getfeildInspection = (data) => {
    let formdata = [],
      inspectionOb = [];

    if (data?.additionalDetails?.fieldinspection_pending?.length > 0) {
      inspectionOb = data?.additionalDetails?.fieldinspection_pending;
    }

    if (data.status == "FIELDINSPECTION_INPROGRESS") {
      formdata = JSON.parse(sessionStorage.getItem("INSPECTION_DATA"));
      formdata?.length > 0 &&
        formdata.map((ob, ind) => {
          inspectionOb.push({
            docs: getInspectionDocs(ob.Documents),
            date: ob.InspectionDate,
            questions: getQuestion(ob),
            time: ob?.InspectionTime,
          });
        });
      inspectionOb = inspectionOb.filter((ob) => ob.docs && ob.docs.length > 0);
    } else {
      sessionStorage.removeItem("INSPECTION_DATA");
    }

    let fieldinspection_pending = [...inspectionOb];
    return fieldinspection_pending;
  };

  async function submit(data) {
    if (developerRemarks) {
      // let workflow = { action: currentAction, comments: developerRemarks, businessService, moduleName: moduleCode };
      const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData) };
      const workflow = {
        action: currentAction?.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        documents: formData?.documents,
        additionalDetails,
        workflow,
        action: currentAction?.action,
        comment: developerRemarks,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      await submitAction({
        BPA: appData,
      });
      if (currentAction?.action === "FIT_FOR_APPROVAL") {
        Modal("Application Approved", `Application Approved Successfully`, "success");
      } else if (currentAction?.action === "REJECTED") {
        Modal("Application Rejected", `Application Rejected, Sent to LTP!`, "success");
      } else if (currentAction?.action === "FORWARD_TO_LTP") {
        Modal("Application Forwarded", `Application Forwarded Successfully to LTP!`, "success");
      }
    } else {
      setStructureCertificateError("Please Enter your Remarks ---------");
    }
  }
  async function selfSubmit(data) {
    if (developerRemarks) {
      // let workflow = { action: currentAction, comments: developerRemarks, businessService, moduleName: moduleCode };
      const additionalDetails = { ...applicationData?.additionalDetails, fieldinspection_pending: getfeildInspection(applicationData) };
      const signdoc = {
        documentType: "signature",
        fileStoreId: uploadedFile,
        isMandatory: true,
        additionalDetails: {
          fileName: file?.name,
          title: "Signature",
        },
      };
      if (!uploadedFile) {
        setStructureCertificateError("Please upload the signature");
        return null;
      }
      const workflow = {
        action: currentAction?.action,
        comment: developerRemarks,
        comments: developerRemarks,
        assignee: null,
        assignes: null,
        varificationDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };
      const appData = {
        ...applicationData,
        documents: [...formData?.documents, signdoc],
        additionalDetails,
        workflow,
        action: currentAction?.action,
        comment: developerRemarks,
        assignee: null,
        wfDocuments: uploadedFile
          ? [
              {
                documentType: currentAction + " DOC",
                fileName: file?.name,
                fileStoreId: uploadedFile,
              },
            ]
          : null,
      };

      await submitAction({
        BPA: appData,
      });
      if (currentAction?.action === "APPROVED") {
        Modal("Application Approved", `Approval Letter Generated Successfully`, "success");
      }
    } else {
      setStructureCertificateError("Please Enter your Remarks and upload signature ---------");
    }
  }

  useEffect(() => {
    getUserInfo();
  }, [user?.info?.uuid]);

  const uniqueTimeline = workflowDetails?.data?.timeline.reduce((acc, checkpoint) => {
    if (!acc.some((item) => item.performedAction === checkpoint.performedAction)) {
      acc.push(checkpoint);
    }
    return acc;
  }, []);

  if (isDataLoading) {
    return <Loader />;
  }
  return (
    <React.Fragment>
      <BackButton />
      <Tabs value={currentTab} onChange={handleChange}>
        {tablist.map(({ label, color }, index) => (
          <Tab label={`${t(label)}`} value={`${index}`} sx={{ textTransform: "none", p: "0 1rem", color }} />
        ))}
      </Tabs>
      <StyledTabPanel value={currentTab} index="0">
        {user?.info?.type === "EMPLOYEE" && (
          <React.Fragment>
            <EmployeeComponent formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} />
            <div style={{ marginRight: "15px" }}>
              <Accordion style={{ marginLeft: "15px", marginTop: "4px" }}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                  style={{ backgroundColor: "aliceblue", borderRadius: "10px", padding: "-1px", border: "2px solid #3d68a0" }}
                >
                  <Typography>
                    <div style={{ display: "flex" }}>
                      <div style={{ marginRight: "15px" }}>
                        <Avatar sx={{ bgcolor: green[500], width: 30, height: 30 }}>
                          <PersonIcon />{" "}
                        </Avatar>
                      </div>
                      <div style={{ marginRight: "15px" }}> {workflowDetails?.data?.timeline?.[0]?.assigner?.name}</div>
                      <div style={{ marginRight: "15px" }}>
                        {" "}
                        ({workflowDetails?.data?.timeline?.[0]?.assigner?.roles?.find((ele) => ele?.code !== "EMPLOYEE")?.name})
                      </div>
                    </div>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ margin: "4px" }}>
                  <Typography style={{ border: "1px solid lightslategrey", borderRadius: "7px", padding: "1%" }}>
                    <div>
                      {" "}
                      {workflowDetails?.data?.timeline?.[0]?.assigner?.name} (
                      {workflowDetails?.data?.timeline?.[0]?.assigner?.roles?.find((ele) => ele?.code !== "EMPLOYEE")?.name})
                    </div>
                    <SafeHtml html={workflowDetails?.data?.timeline?.[0]?.wfComment?.[0]} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </React.Fragment>
        )}

        {user?.info?.type === "CITIZEN" && workflowDetails?.data?.nextActions?.[0]?.action != "ISSUE_STRUCTURAL_STABILITY_CERTIFICATE" && (
          <Architect formData={formData} applicationDocs={applicationDocs} totalAmount={totalAmount} actions={actions} isSelf={isSelf} />
        )}
        {formData?.status !== "APPROVED" &&
          (formData?.status === "MAKE_PAYMENT_APPLICATION_FEE_FIRST" ||
            formData?.status === "MAKE_PAYMENT_BY_ARCHITECT" ||
            formData?.status === "MAKE_PAYMENT_SELF" ||
            formData?.status === "MAKE_PAYMENT_APPLICATION_FEE" ||
            formData?.status === "MAKE_PAYMENT" ||
            formData?.status === "MAKE_PAYMENT_SELF_REGENERATE") && (
            <div style={{ padding: "10px" }}>
              <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                <Box gridColumn="span 2">
                  <b>Action </b>
                </Box>
                <Box gridColumn="span 10">
                  <RadioButtons
                    isMandatory={false}
                    options={actions}
                    selectedOption={currentAction}
                    optionsKey="action"
                    onSelect={onRadioActionSelect}
                    style={{ display: "flex", gap: "3rem", margin: 0 }}
                  />
                </Box>
                <Box gridColumn="span 2">
                  <Box gridColumn="span 2">
                    <b>Check Payment Status </b>
                  </Box>
                </Box>
                <Box gridColumn="span 10">
                  <ButtonWrapper
                    variant="contained"
                    color="success"
                    size="medium"
                    label="Click here"
                    type="button"
                    onClick={() => checkPaymentStatus(formData?.applicationNo)}
                    sx={{ backgroundColor: "#157CB3", width: "109px" }}
                  />
                </Box>
                {/* {currentAction?.action === 'FORWARD_TO_LTP' && ( <Box gridColumn="span 2">
              <b>Declaration </b>
            </Box>)} */}
                {/* {currentAction?.action === 'FORWARD_TO_LTP' && (<Box gridColumn="span 10">
              <FormControlLabel
                //style={{ padding: '10px 15px' }}
                control={
                  <Checkbox
                    name="declaration"
                    checked={declarationChecked}
                    onChange={handleDeclarationChange}
                  />
                }
                label={
                  <span>
                    This project is based on the inputs and documents provided by the Licensed Technical Professional (LTP). It is entirely reliant on the trust and verification conducted by the LTP.
                  </span>
                }
              />
            </Box>)} */}
                <Box gridColumn="span 2">
                  <b>Remark </b>
                </Box>
                <Box gridColumn="span 10">
                  <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks}></DemoParinted>
                </Box>
              </Box>

              {(user?.info?.type != "CITIZEN" || formData?.planOn === "SELF_MAP") && currentAction?.action === "APPROVED" && (
                <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                  <Box gridColumn="span 2">Upload Signature</Box>
                  <Box gridColumn="span 10">
                    <UploadFile
                      id={"workflow-doc"}
                      onUpload={selectFile}
                      onDelete={() => {
                        setUploadedFile(null);
                      }}
                      message={uploadedFile ? `1 ${t(`ES_PT_ACTION_FILEUPLOADED`)}` : t(`CS_ACTION_NO_FILEUPLOADED`)}
                      accept="image/*, .png, .jpeg, .jpg"
                      iserror={error}
                      required={true}
                      showHint={true}
                      hintText="Please upload a file, Accepted formats: JPG, PNG, JPEG, "
                    />
                  </Box>
                </Box>
              )}
              {currentAction && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                    <Box gridColumn="span 2"></Box>
                    {currentAction?.action === "FORWARD_TO_LTP" && ["OWNER"].some((role) => userRoles?.includes(role)) && (
                      <Box gridColumn="span 10">
                        <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                          Submit
                        </Button>
                      </Box>
                    )}
                    {(currentAction?.action === "APPROVED" || currentAction?.action === "FIT_FOR_APPROVAL") && isLTP && (
                      <Box gridColumn="span 10">
                        <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                          Submit
                        </Button>
                      </Box>
                    )}
                    {(currentAction?.action === "APPROVED" || currentAction?.action === "FIT_FOR_APPROVAL") &&
                      ["OWNER"].some((role) => userRoles?.includes(role)) && (
                        <Box gridColumn="span 10">
                          <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={selfSubmit}>
                            Submit
                          </Button>
                        </Box>
                      )}
                    {currentAction?.action === "REJECTED" && ["OWNER"].some((role) => userRoles?.includes(role)) && (
                      <Box gridColumn="span 10">
                        <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={submit}>
                          Submit
                        </Button>
                      </Box>
                    )}
                  </Box>
                  {/* {currentAction?.action === "FORWARD_TO_LTP" &&
                <Dialog open={!open} onClose={() => setOpen(true)}>
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      As the owner, I have checked and reviewed the complete Map Submission Form and documents, and I fully agree with them.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setOpen(true)} color="primary" variant="contained">OK</Button>
                  </DialogActions>
                </Dialog>} */}
                </div>
              )}

              {currentAction && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                    <Box gridColumn="span 2"></Box>
                    {(currentAction.action === "MAKE_PAYMENT" || currentAction.action === "MAKE_PAYMENT_SELF") && (
                      <Box gridColumn="span 10">
                        <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={routetoPay}>
                          Make Payment
                        </Button>
                      </Box>
                    )}
                  </Box>
                </div>
              )}
            </div>
          )}

        <div style={{ color: "red" }}>
          <marquee> {structureCertificateError}</marquee>
        </div>
      </StyledTabPanel>
      <StyledTabPanel value={currentTab} index="1">
        {showTimeLine && workflowDetails?.data?.timeline?.length > 0 && (
          <React.Fragment>
            {/* <BreakLine />
            {(workflowDetails?.isLoading || isDataLoading) && <Loader />}
            {!workflowDetails?.isLoading && !isDataLoading && (
              <Fragment>
                <CardSectionHeader style={{ marginBottom: "16px", marginTop: "32px" }}>
                  {t("ES_APPLICATION_DETAILS_APPLICATION_ALL_REMARKS")}
                </CardSectionHeader>
                {workflowDetails?.data?.timeline && workflowDetails?.data?.timeline?.length === 1 ? (
                  <Card style={{ backgroundColor: "aliceblue", borderRadius: "20px" }}>
                    <CheckPoint
                      isCompleted={true}
                      label={t(`${timelineStatusPrefix}${workflowDetails?.data?.timeline[0]?.state}`)}
                      customChild={getTimelineCaptions(workflowDetails?.data?.timeline[0])}
                    />
                  </Card>
                ) : (
                  <ConnectingCheckPoints>
                    {uniqueTimeline &&
                      uniqueTimeline.map((checkpoint, index, arr) => {
                        return (
                          <React.Fragment key={index}>
                            <Card style={{ backgroundColor: "aliceblue", borderRadius: "20px" }}>
                              <CheckPoint
                                keyValue={index}
                                isCompleted={index === 0}
                                info={checkpoint.comment}
                                label={t(
                                  `${timelineStatusPrefix}${checkpoint?.performedAction === "REOPEN" ? checkpoint?.performedAction : checkpoint?.performedAction
                                  }`
                                )}
                                customChild={getTimelineCaptions(checkpoint)}
                              /></Card>
                          </React.Fragment>
                        );
                      })}
                  </ConnectingCheckPoints>
                )}
              </Fragment>
            )} */}
            <AllRemarksList remarkDataResps={workflowDetails?.data} />
          </React.Fragment>
        )}
      </StyledTabPanel>
      {!isSelfCert && !isSelf && chatboardIndex !== -1 && (
        <StyledTabPanel value={currentTab} index={`${chatboardIndex}`}>
          <div>{user?.info?.type === "CITIZEN" && <ChatboardCorrespondenceApplicant formData={formData} />}</div>
        </StyledTabPanel>
      )}
      {isSelfCert && formData?.status === "MAKE_PAYMENT_SELF" && feeDetailsIndex !== -1 && (
        <StyledTabPanel value={currentTab} index={`${feeDetailsIndex}`}>
          <Step3 formData={formData} handleTabChange={handlePayment} />
        </StyledTabPanel>
      )}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
      <Dialog open={openApplicantPopup} onClose={handleModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" style={{ textAlign: "center", fontSize: "35px" }}>
          Thanks You!{" "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>
              <CheckCircleOutlineIcon style={{ color: "green", variant: "filled", margin: "0px 40% 0", fontSize: "100px", padding: "2px" }} />
            </p>
            <p style={{ textAlign: "center", fontSize: "15px" }}>
              <p>Your Action Has been Completed. Please Note Down </p>
              {/* <p>{userRolesArray?.[0]?.code}</p>  */}
              <p>Map Submission </p>
              <p>
                {" "}
                Application no <span style={{ padding: "5px", color: "blue" }}>{id}</span> is Done Successfully.{" "}
              </p>
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModal} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default Form12Summary;
